import * as ng from 'angular';
import { ComponentRegistration } from '../../../core';
import { Dto } from '../../../data';
import { IUserAdminService } from './../';
let template = require('./users-grid.html');

class UsersGridComponent extends ComponentRegistration {

    constructor() {
        super('usersGrid', {
            controller: UsersGridController,
            templateUrl: template,
            controllerAs: 'vm',
            bindings: {
                userSelected: '&?',
                addUser: '&?',
                selectedUser: '<?'
            }
        });
    }
}

interface IUsersGridController {

}

class UsersGridController implements IUsersGridController {
    private static $inject: Array<string> = ['$q', '$rootRouter', 'UserAdmin'];
    private profile: Dto.IProfile;
    private criteria: Dto.IProfileCriteria;
    private profiles: Dto.IProfile[];
    private _selectedUser: Dto.IProfile;
    //Bindings
    private userSelected: Function;
    private addUser: Function;


    constructor(private $q: ng.IQService,
        private $rootRouter: ng.Router,
        private UserAdmin: IUserAdminService) {
        console.log('UsersGridController loading');
        this.activate();
    }

    public activate(): void {
        console.log('UsersGridController loaded');
    }

    public $onInit(): void {
        this.criteria = {
            pageSize: 25,
            pageNumber: 1,
            isAdmin: true
        } as Dto.IProfileCriteria;
        this.search(this.criteria);
    }

    public get selectedUser(): Dto.IProfile {
        return this._selectedUser;
    }

    public set selectedUser(val: Dto.IProfile) {
        if (this._selectedUser !== val) {
            this._selectedUser = val;
            this.criteria.pageNumber = 1;
            this.search(this.criteria);
        }
    }

    public search(criteria?: Dto.IProfileCriteria): ng.IPromise<Array<Dto.IProfile>> {
        return this.UserAdmin.search(criteria).then((profiles) => {
            this.profiles = profiles;
            this.raiseUserSelected();
            return this.$q.resolve(this.profiles);
        });
    }

    public criteriaChanged(args) {
        this.criteria = args.criteria;
        this.search(this.criteria);
    }

    private onAdd(e): void {
        this.raiseAddUser();
    }

    public onRowSelect(selectedRow): void {
        if (!selectedRow) {
            this.raiseUserSelected();
            return;
        }
        this.raiseUserSelected(selectedRow.entity);
    }

    public raiseUserSelected(profile?: Dto.IProfile): void {
        if (typeof this.userSelected === 'function') {
            this.userSelected({ profile: profile });
        }
    }

    public raiseAddUser(): void {
        if (typeof this.addUser === 'function') {
            this.addUser();
        }
    }
}

let usersGridComponent = new UsersGridComponent();
export default usersGridComponent;
export { usersGridComponent as UsersGridComponent, IUsersGridController, UsersGridController }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/admin/users/users-grid.ts